/**
 * Loads data stored within a DOM element using the `bootstrap` namespace
 * @param  {string} id
 * @return {(Object|undefined)}
 */
export function bootstrapData(id, safe) {
  const el = document.getElementById(`bootstrap-${id}`);

  if (el == null) return {};

  if (safe) {
    return JSON.parse(el.innerHTML);
  } else {
    const escapedData = el.innerHTML;
    const div = document.createElement('div');

    div.innerHTML = escapedData;

    return JSON.parse(div.innerText);
  }
}

/**
 * add a node after the specified node
 * @param {Node} newNode - the node to insert into the document
 * @param {Node} referenceNode - the Node that newNode should be inserted after
 */
export function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
